<template>
  <el-dialog :visible.sync="showDialog" title="票据选择" width="600px" :show-close="false" append-to-body
             :close-on-click-modal='false' :close-on-press-escape='false'>
    <custom-table ref="customTable" emptyText="请先领取票据后下单" :customOptions="customOptions" :columns="columns"
                  :has-organization="false" :paging="false" maxHeight="300">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right" v-slot="{row}">
          <el-button type="text" size="small" @click="selectPush(row)">选择</el-button>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <div v-if="item.prop == 'created'">{{ row.created | filterTime }}</div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </custom-table>
    <el-button @click="$router.back()" type="primary" style="width:100%;margin: 20px 0;">退出</el-button>
  </el-dialog>
</template>

<script>
export default {
  name: "selectVote",
  props: {
    value: {
      default: false
    }
  },
  data() {
    return {
      showDialog: false,
      customOptions: {
        url: '/api/v1/manage/order/manage/ticket',
        params: {
          page: 1, // 页数
          size: 999, // 每页条数
        }
      },
      columns: [
        {prop: 'ticketCurrentNo', label: '当前票号'},
        {prop: 'remainingNum', label: '剩余张数', width: 100},
        {prop: 'created', label: '入库时间', width: 150},
      ],
    }
  },
  watch: {
    value: {
      handler() {
        this.showDialog = this.value
        this.$nextTick(()=>{
          this.value && this.$refs.customTable.listFn()
        })
      },
      immediate: true
    }
  },
  methods: {
    selectPush(row) {
      this.$emit('handChange', row)
    }
  }
}
</script>

<style scoped>

</style>